// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-V":"V_dpu-detail-V___r121"};